import React from 'react';
import WebinarFilter from './WebinarFilter';
import { WebinarBanner, WebinarPage } from '../Webinars.types';

interface WebinarBannerProps {
  bannerInfo: WebinarBanner;
  webinarPage: WebinarPage;
}

const WebinarBanner = ({ bannerInfo: result, webinarPage }: WebinarBannerProps) => {
  const bannerVideo = result?.BannerVideo;
  const desktopBanner = result?.DesktopBanner;
  const desktopBannerAltText = result?.DesktopBannerAltText;
  const mobileBanner = result?.MobileBanner;
  const mobileBannerAltText = result?.MobileBannerAltText;
  const fontColor = 'webinarColorWhite';

  return (
    <div className='webinarBanner'>
      {mobileBanner && (
        <div>
          <img
            className='onlyMobile content'
            alt={mobileBannerAltText}
            src={mobileBanner}
            height='360'
            width='640'
          />
        </div>
      )}
      {bannerVideo ? (
        <video className='w-video is-desktop' id='myVideo' autoPlay={true} loop={true} muted>
          <source src={bannerVideo} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      ) : (
        desktopBanner && (
          <div>
            <img
              loading='lazy'
              className='is-desktop content'
              style={{ height: '480px' }}
              src={desktopBanner}
              alt={desktopBannerAltText}
              width='1920'
            />
          </div>
        )
      )}
      <div className='content'> </div>
      <div className='banner-section'>
        {/* User Story 476216: Mandatory H1 title implementation. Added an <h1> tag inside the <div> element to improve the heading structure.  */}
        <h1 className={'bannerHeading ' + fontColor}> {result?.Heading || ''}</h1>
        <div
          className={'bannerDescription ' + fontColor}
          dangerouslySetInnerHTML={{
            __html: result?.Description
              ? result.Description.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')
              : '',
          }}
        ></div>
        <div className='banner-subheading'>
          <WebinarFilter
            subHeading={result?.SubHeading || ''}
            webinarCategories={webinarPage.CategoriesInEnglish}
            webinarTypes={webinarPage.WebinarTypesInEnglish}
            categoriesFilterLabel={webinarPage.IndustriesLabel}
            typesFilterLabel={webinarPage.LiveLabel}
            filterPlaceholder={webinarPage.All}
          />
        </div>
      </div>
    </div>
  );
};

export default WebinarBanner;
